module.exports = __webpack_public_path__ + "img/92.485e867b.jpg";